module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('section', {
    staticClass: "count-down"
  }, [_c('div', {
    staticClass: "icons"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-video"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "info-wrapper"
  }, [_c('h2', [_vm._v("距离开播还有")]), _vm._v(" "), _c('h1', [_vm._v(" " + _vm._s(_vm.countDown))])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cabaefa"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CountDown/CountDown.vue
// module id = 528
// module chunks = 1